import type { CrudFilter } from "@refinedev/core";

/**
 * `/matches?leagueId=X` → leagueId:=X; `/matches?teamId=T` → home OR away team T
 * (rendered by `transformFilter` as `(homeTeamId:=T || awayTeamId:=T)`).
 */
export function matchUrlFilters(search: URLSearchParams): CrudFilter[] {
  const filters: CrudFilter[] = [];
  const leagueId = search.get("leagueId");
  if (leagueId) {
    filters.push({ field: "leagueId", operator: "eq", value: leagueId });
  }
  const teamId = search.get("teamId");
  if (teamId) {
    filters.push({
      operator: "or",
      value: [
        { field: "homeTeamId", operator: "eq", value: teamId },
        { field: "awayTeamId", operator: "eq", value: teamId },
      ],
    });
  }
  return filters;
}
